module.exports = __webpack_public_path__ + "img/新建运单.f3645d57.svg";